import { render, staticRenderFns } from "./VerifyPoints.vue?vue&type=template&id=2d70b13a"
import script from "./VerifyPoints.vue?vue&type=script&lang=js"
export * from "./VerifyPoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports